import { asyncData } from './asyncData';
import { mapAsyncData } from '@/plugins/asyncData';
import useStore from './_store';
export default {
    asyncData: mapAsyncData(asyncData),
    _getUseStore: useStore,
};
